module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/sven-hastedt-bkg-3a27bea6c12bb97e0d8be19e3e413db0.jpg";